import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useRemoveAccountLogoMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: async ({ impersonationContext }: { impersonationContext?: Api.IImpersonationContext }) => {
			const result = await userSession.webServiceHelper.callAsync<void>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'account/preferences/logo',
					impersonationContext,
				}),
				'DELETE'
			);
			return result;
		},
		onError,
		onSuccess,
	});
}
